module.exports = __webpack_public_path__ + "static/media/newSecure.3efa75a9.svg";